import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
  signal,
  viewChild
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  NgForm,
  NonNullableFormBuilder,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CommonHttpService } from '@shared/data';
import { FieldValidationMsgPipe } from '@shared/pipes';
import { NotificationService } from '@shared/services';
import { copyToClipboard, isFormValid } from '@shared/utils';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';

@Component({
  selector: 'moxi-encrypt',
  imports: [
    FieldValidationMsgPipe,

    TranslatePipe,

    // Ant Design
    FormsModule,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzModalModule,
    NzIconModule
  ],
  templateUrl: './encrypt.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EncryptComponent implements OnInit {
  private readonly commonService = inject(CommonHttpService);
  private readonly notificationService = inject(NotificationService);
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly translateService = inject(TranslateService);

  encryptedResult = signal<string | null>(null);
  openModal = signal(false);

  encryptForm = new FormGroup({
    value: new FormControl(null, {
      validators: [Validators.required],
      updateOn: 'blur'
    })
  });

  ngForm = viewChild<NgForm>('form');

  ngOnInit(): void {
    this.fb.group(this.encryptForm);
  }

  onEncryptionSubmit(): void {
    if (isFormValid(this.encryptForm)) {
      const value = this.encryptForm.controls.value.value as string;

      this.commonService.encryptValue(value).subscribe(result => {
        this.encryptedResult.set(result);

        copyToClipboard(result).subscribe({
          error: () => {
            this.notificationService.error(
              this.translateService.instant('shared.encrypt.errorMsg', {
                value: result
              })
            );
          },
          complete: () => {
            this.notificationService.success('shared.encrypt.successMsg');
          }
        });
      });
    }
  }
}
